import Marionette from "../../../shared/marionette-mustache";
import { LegislationRelationModel } from "../../../desktop/models/legislation-relation";
import { backboneViewProperties } from "../../../decorators/backbone-properties";

@backboneViewProperties({
    tagName: "div",
})
export class LegislationRelationView extends Marionette.ItemView<LegislationRelationModel> {
    constructor(options?: Backbone.ViewOptions<LegislationRelationModel>) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/partials/legislation-relation.ts